import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export function OrderCollection(props: IconProps = {}): JSX.Element {
  const { ...rest } = props;

  return (
    <SvgIcon name="OrderCollection" {...rest}>
      <path
        d="M8.4 9.7V5.1a3.6 3.6 0 017.2 0v4.6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M20 9v13H4V9h16zm2-2H2v17h20V7z" fill="currentColor" />
    </SvgIcon>
  );
}
